import { render, staticRenderFns } from "./UserAccountManager.vue?vue&type=template&id=2ac47ed5&"
import script from "./UserAccountManager.vue?vue&type=script&lang=js&"
export * from "./UserAccountManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports